import { RequestConfig } from '~/common/services/requests';
import { FormContext } from '../../../../types';
import { Entity } from '../../../../types/utility';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postApplicationFormSubmit = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: Entity,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Record<string, FormContext>> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/form/submit`,
    {
      data,
      params,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
